import * as yup from "yup";

const testIsMaxTwoDigits = (val: number | undefined) => {
  if (val != undefined) {
    return twoDecimalsPattern.test(`${val}`);
  }
  return true;
};

const TWO_DECIMALS_ERROR_MESSAGE = "Max two decimals are allowed.";
const WEIGHT_AMOUNT_ERROR_MESSAGE = "Weight must be between 0 and 5000";
const PERCENTAGE_AMOUNT_ERROR_MESSAGE = "Shrinkage must be between 0% and 100%";

const twoDecimalsPattern = /^\d+(\.\d{0,2})?$/;

const isTwoDigits = ["max-two-decimals", TWO_DECIMALS_ERROR_MESSAGE, testIsMaxTwoDigits] as const;

export type TransactionValidationSchema = yup.InferType<typeof transactionValidationSchema>;

export const transactionValidationSchema = yup.object({
  date: yup.date().required("Transaction date is a required field."),
  type: yup.mixed<"purchase" | "sale">().oneOf(["purchase", "sale"]).required(),
  description: yup.string().max(50),
  totalAmount: yup.string().required("Total price is a required field."),
  perHeadAmount: yup.string(),
  payWeight: yup
    .number()
    .transform((value: number) => (Number.isNaN(value) ? 0 : value))
    .min(0, WEIGHT_AMOUNT_ERROR_MESSAGE)
    .max(5000, WEIGHT_AMOUNT_ERROR_MESSAGE)
    .test(...isTwoDigits),
  grossWeight: yup
    .number()
    .transform((value: number) => (Number.isNaN(value) ? 0 : value))
    .min(0, WEIGHT_AMOUNT_ERROR_MESSAGE)
    .max(5000, WEIGHT_AMOUNT_ERROR_MESSAGE)
    .test(...isTwoDigits),
  shrinkage: yup
    .number()
    .transform((value: number) => (Number.isNaN(value) ? 0 : value))
    .min(0, PERCENTAGE_AMOUNT_ERROR_MESSAGE)
    .max(100, PERCENTAGE_AMOUNT_ERROR_MESSAGE)
    .test(...isTwoDigits),
  contactId: yup.string(),
});
